module.exports = {
  disableTournamentCasinoPortrait: false,
  skin: 'gamedaddy', // SKINS ====> ['gamedaddy', 'betpassion'],
  maskNickname: true,
  showLastBetToaster: false,
  hasYoutubeLinkOnHowToPlayPage: true,
  tournamentsHistoryPageItemsLimit: 1000,
  hasTextOnTournamentHistoryWidgetBanner: false,
  mulicurrency : {
    autoConvertToPlayerCurrency:  false,
    enableCurrencySwitcherMenu:  false,
  },
  showNetworkErrorToaster: false,
  withOutForceFullScreen: false,
  hasBigLeaderboard: false,
  enableJackpot: true,
  naviagtion: {
    hasCashGames: true,
    hasWOS: true,
  }
};
